import { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useSites } from 'store'

import { convertDateRange } from '../../hooks/use-traffic'
import { useGetStatsTimeRange } from '../../store'

const OPERATION_TRAFFIC = gql`
  query TrafficDistributionGroupBySsid($sfIds: [ID], $startsAt: String, $endsAt: String) {
    stats: trafficDistributionGroupBySsid(sf_ids: $sfIds, starts_at: $startsAt, ends_at: $endsAt) {
      ssid_name
      network_name
      download
      upload
    }
  }
`

const useData = () => {
  const [globalRange] = useGetStatsTimeRange()
  const [{ selected }] = useSites()

  const {data, loading} = useQuery(OPERATION_TRAFFIC, {
    variables: {
      sfIds: selected.map(({sf_id}) => sf_id),
      ...convertDateRange(globalRange)
    }
  })

  const formattedData = useMemo(() => {
    if (!data) {
      return []
    }
    return data.stats
      .filter(({download, upload}) => parseInt(download) + parseInt(upload) > 0)
      .map(values => {
        return {
          network_name: values.network_name,
          name: values.ssid_name,
          download: parseInt(values.download) / 1000,
          upload: parseInt(values.upload) / 1000
        }
      })
  }, [data])

  const ssids = useMemo(() => {
    const total = formattedData.reduce((total, {download, upload}) => total + download + upload,0)

    return formattedData.map(data => {
      const percentage = (((data.download + data.upload) * 100) / total).toFixed(1)
      return {
        ...data,
        percentage,
        total: data.download + data.upload
      }
    })
  }, [formattedData])

  return {
    loading,
    data: ssids
  }
}


export default useData